import { FormattedMessage } from 'react-intl';

import styles from './WarningLabel.module.scss';

type WarningLabelProps = {
  label: TranslationId;
  margin?: React.CSSProperties['margin'];
  onClick: React.MouseEventHandler;
  testId?: string;
};

const WarningLabel = ({ label, margin, onClick, testId }: WarningLabelProps) => {
  return (
    <div className={styles.root} style={{ margin }} onClick={onClick} data-testid={testId}>
      <FormattedMessage id={label} />
    </div>
  );
};

export default WarningLabel;
